<!-- 高标仓 -->
<template>
    <div class="high-box">
        <div class="high-top">
            <div class="high-export">
                <MessageHeader msg="仓储数据总览"></MessageHeader>
<!--                <el-button @click="exportData"><el-image :src="exportImg"/>数据导出</el-button>-->
            </div>
            <div class="data-list">
                <el-row :gutter="20">
                    <el-col :span="4" v-for="(item, key, index) in dataList" :key="key">
                        <CompareItem
                           :item="item" :name="keys[key] ? keys[key].str : ''"
                           :unit="keys[key] ? keys[key].unit : ''"
                           :process="keys[key] ? keys[key].process : ''"
                           :top="28"
                           :index="index"
                           :itemBgs="[0,1,2,3,4,5,6]"
                           :tipText="keys[key].tipText"
                           :hiddenCircle="keys[key] ? keys[key].hiddenCircle : false"
                           :hiddenSame="keys[key]? keys[key].hiddenSame : false"
                           :format="keys[key].format"
                        >
                        </CompareItem>
                    </el-col>
                </el-row>
            </div>

<!--租户行业分布 @current-change="handleCurrentChange"-->
            <div class="data-chart">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">租户行业分布</p>

                            <div class="chart-style-box" style="position: relative;">
                                <no-data
                                  :visible="emptyArray(industryDistribution)"
                                />
                                <PieChart :data="industryDistribution"></PieChart>
                            </div>
                        </div>

                    </el-col>
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">市场体量分析</p>
                            <div class="chart-style-box1">
                                <Pies
                                    title="总量"
                                      :color="['#447FF8', '#AFB7C1']"
                                      :data="marketVolume"
                                        y-center :radius="['40%', '50%']" :legend="{
                                        left: 'center',
                                        bottom: 0,
                                        show: true,
                                        orient: 'vertical',
                                        icon: 'circle',
                                        itemWidth: 8,
                                        itemHeight: 8,

                                    }"/>
<!--                                    <div class="chart-center-style">-->
<!--                                        <span class="jiantou"></span>-->
<!--                                        <span>现有存量</span>-->
<!--                                    </div>-->
                                    <Pies title="现有存量" :color="['#BC5EEB', '#5C67FB']"
                                      :data="currentInventory"
                                      :radius="['30%', '38%']" y-center
                                      :legend="{
                                        left: 'center',
                                        bottom: 0,
                                        show: true,
                                        orient: 'vertical',
                                        icon: 'circle',
                                        itemWidth: 8,
                                        itemHeight: 8,
                                    }"/>
                            </div>
                            
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="data-chart" style="margin-top: 20px;">
              <div class="chart-style">
                <p class="u-agg-aii-ct">预计增量</p>
                <div class="chart-style-box">
                  <high-predict-addtional
                      :data="expectNewData"
                  />
                </div>
              </div>
            </div>
        </div>
      <!--项目数据一览-->
      <div class="child-list">
        <MessageHeader
            msg="项目数据一览"
            tip-text="点击项目名称查看项目洞察"
        />
        <div class="child-table rs-el-table">
          <el-table
              :data="formatChildData"
              style="width: 100%; height: 360px;color: #666;background-color: #fff;font-size: 14px;"
              class="top"
              :show-summary="false"
              header-row-class-name="tableHeader"
              :header-cell-style="{'text-align':'center'}"
          >
            <el-table-column
                v-for="item in tableHeadProject"
                :prop="item.props"
                :label="item.label"
                :key="item.label"
                :width="item.width||''"
                :type="item.type"
                :align="item.align"
                :header-align="item.headerAlign"
            >
              <template v-if="item.tipText" #header>
                  <span class="header-lable">{{item.label}}
                      <el-tooltip :content="item.tipText" placement="top" effect="light">
                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                      </el-tooltip>
                  </span>
              </template>
              <template
                  v-if="item.location"
                  #default="scope"
              >
                <span
                    class="router-link"
                    v-if="scope.row['rptNumber'].startsWith('F')" :title="scope.row[item.props]">{{scope.row[item.props]}}</span>
                <router-link
                    v-else
                    class="router-link"
                    style="text-decoration: none;color: #1D83E6;"
                    :to="useInsightProject(scope.row['rptNumber'])"
                    :title="scope.row[item.props]"
                >
                    {{scope.row[item.props]}}
                </router-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="ed-project-pagination" style="display: flex; justify-content: flex-end; margin-top: 10px;">
            <el-pagination
                :total="childDataPageTotal"
                :page-size="childDataPageSize"
                background
                layout="total, prev, pager, next, jumper"
                small
                @current-change="handlePageDataChange"
            />
          </div>
        </div>
      </div>

        <div class="chart-list">
            <MessageHeader msg="租金与空置率情况"></MessageHeader>
            <div class="chart-items-box">
                <div class="chart-item-left">
                    <p class="u-agg-aii-ct">预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                      color="#0A9BFC"
                      :linearGradient="['rgba(10, 155, 252, 0.8)','rgba(255, 255, 255, 0)']"
                      :options="['name', 'rent', 'vacancyRate']"
                      :showLabel="['预估有效租金', '空置率']"
                      :labelOptions="['', '']"
                      :value-format="[rentPriceFormat, vacancyRateWithSuffix]"
                      :label-format="['(元/㎡·月)', '']"
                      :data="timeList"
                    />
                </div>
                <div class="chart-item-right">
                    <p class="u-agg-aii-ct">品牌开发商预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                      color="#31C9E8"
                      :linearGradient="['rgba(49, 201, 232, 0.8)','rgba(255, 255, 255, 0)']"
                      :options="['name', 'rent', 'vacancyRate']"
                      :showLabel="['预估有效租金', '空置率']"
                      :labelOptions="['', '']"
                      :label-format="['(元/㎡·月)', '']"
                      :value-format="[null, vacancyRateWithSuffix]"
                      :data="calcDevList"
                    />
                </div>
            </div>
            <!-- <div class="chart-item">
                <BarAndLine
                    title="预估有效租金和空置率趋势"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#2C5FE1','#76BAFF', '#FE9A0A']"
                    :showLine="2" :data="timeList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div>
            <div class="chart-item">
                <BarAndLine
                    title="品牌开发商预估有效租金与空置率情况"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#0053C2','#41D1FF', '#FE9A0A']"
                    :showLine="0"
                    :data="devList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div> -->

        </div>

<!--租赁市场动态-->
        <div class="dynamic-box">
            <MessageHeader msg="租赁市场动态"></MessageHeader>
            <div class="dynamic-table">
                <ScrollTable :tableHead="tableHead" :table-data="dynamicsData"/>
            </div>
        </div>

    </div>
</template>
<script setup>
import request from "@/service/request";
import {
  exportCityHigh,
  exportCityHighTime,
  GatherCityAreaData, GetCityAreaExpectNew, GetCityAreaMarketDynamics,
  GetCityAreaProjectPageList,
  GetCityAreaTenant, GetCityEstimatedRentVacancy,
  GetCityMassAnalysis, GetCurrentInventory, GetDeveloperRentVacancyRate,
} from "@/service/api";
import {computed, ref, watch} from "vue";
import CompareItem from '@/components/compareItem'
import MessageHeader from '@/components/MessageHeader'
import Pies from '@/components/charts/chartsPie'
import ScrollTable from '@/components/scrollTable'
import PieChart from '@/components/charts/nChartsPie.vue'
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import {exportFile} from "@/tool/public";
import {
  effectiveRent,
  emptyArray,
  rentPriceFormat,
  vacancyRate,
  vacancyRateNoMultiply, vacancyRateNoSuffixMultiply,
  warehouseArea,
  keys, vacancyRateMultiply, vacancyRateWithSuffix
} from "@/tool/number";
import NoData from "@/components/noData.vue";
import HighPredictAddtional from "@/view/insight/urban/components/highPredictAddtional.vue";
import {useInsightProject} from "@/router/linkroute";


// 增加一个后台的接口
const expectNew = ref([])
const expectNewData = computed(() => {
  return expectNew.value.map(e => {
    const calc = (c, n) => {
      const key = n["quarter"].substr(5);
      c[key] = n["expectValue"]
      return c;
    }
    return e['list'].reduce(calc, {year: e['year'], total: e['total']});
  })
})
const getExpectNewData = async () => {
  if(!props.code) return;
  const { data } = await request({
    method: 'get',
    url: GetCityAreaExpectNew,
    data: {
      areaCode: props.code
    }
  })
  expectNew.value = data;
}


let mapTime = localStorage.getItem('mapTime')
// 导出
const exportData = async () => {
    let data = await request({
        url: exportCityHigh,
        method: 'post',
        data: {
            quarter:[mapTime]
        },
        download: true,
        responseType: 'blob',
    })
    await exportTime()
    exportFile(data, '高标仓城市层级数据')
}
const exportTime = async () => {
    await request({
        url: exportCityHighTime,
        method: 'post',
        data: {
            quarter:[mapTime]
        },
    })
}

const props = defineProps({
    code: {
        type: String,
        default: ''
    }
})


let dataInfo = ref({})
/** 高标仓数据总览对应关系  **/


const color = ['#447FF8', '#5C67FB', '#BC5EEB', '#F9545A', '#F99807', '#FFC70D', '#7FCD49']

const dataList = ref({})

/**仓储数据总览**/
const getWarehouse = async () => {
    let {data} = await request({
        url: GatherCityAreaData,
        method: 'get',
        data: {areaCode: props.code}
    })
    let obj = {}
    for (let key in keys) {
      if(data[key])  obj[key] = data[key]
      else obj[key] = {
        "metricValue": 0,
        "metricValueYOY": 0,
        "metricValueMOM": 0
      }
    }
    dataList.value = obj
    dataInfo.value = data
}
let childData = ref([])
const tableHeadProject = ref([
  {label: '序号', align: 'center', width: 60, type: 'index', headerAlign: 'center'},
  {props: 'projectName', label: '项目名称', align: 'left', location: true},
  {props: 'areaTotal', label: '现有存量（㎡)', width: 140, tipText: '建成面积（包含本季度增量）'},
  {props: 'expectNew', label: '预计增量(㎡)', width: 140, tipText: '预计投入市场的面积'},
  {props: 'vacancyRate', label: '空置率', width: 80, align:'center', headerAlign:'center'},
  {props: 'effectiveRent', label: '预估有效租金(元/㎡·月)', width: 200, align:'center', headerAlign:'center', tipText: '折算免租期、装修期后的租金'},
  {props: 'buildingState', label: '建成状态', width: 100},
  {props: 'buildingDate', label: '预计建成时间', width: 130},
  {props: 'buildType', label: '建筑类型', width: 100},
])

const childDataPageSize = ref(5)
const childDataPageNumber = ref(1)
const childDataPageTotal = ref(0);
watch(childDataPageNumber, () => {
  getChildData();
})
const handlePageDataChange = (v) => {
  childDataPageNumber.value = v;
}
let formatChildData = computed(() => {
  if(emptyArray(childData.value)){ return []; }
  return childData.value.map((e) => {
    return{
      ...e,
      areaTotal: warehouseArea(e.areaTotal),
      expectNew: warehouseArea(e.expectNew),
      'vacancyRate': vacancyRateNoMultiply(e.vacancyRate),
      'effectiveRent': effectiveRent(e.effectiveRent)
    }
  })
})
/** 项目数据一览 **/
const getChildData = async () => {
    let {rows, total} = await request({
        url: GetCityAreaProjectPageList,
        method: 'post',
        data: {
          areaCode: props.code,
          pageSize: childDataPageSize.value,
          pageNum: childDataPageNumber.value
        }
    })
    childDataPageTotal.value = total;
    childData.value = rows
}
/***时间趋势*/
let timeList = ref([])
let devList = ref([])

const calcDevList = computed(() => {
  return devList.value.map(({rent, vacancyRate: v, ...rest}) => {
    return {
        ...rest,
        rent: rentPriceFormat(rent),
        vacancyRate: vacancyRateMultiply(v)
    }
  })
})

const getChartInfo = async () => {
    let time = await request({
        url: GetCityEstimatedRentVacancy,
        method: 'get',
        data: {areaCode: props.code}
    })

    let dev = await request({
        url: GetDeveloperRentVacancyRate,
        method: 'get',
        data: {areaCode: props.code}
    })

    timeList.value = time.data
    devList.value = dev.data
}

let dynamicsData = ref([])
const tableHead = ref([
    {label: '序号', align: 'center', width: 70, type: 'index'},
    {props: 'tenantName', label: '租户', align: 'left', width: 200},
    {props: 'areaName', label: '区县', width: 100, align: 'left'},
    {props: 'projectName', label: '项目名称', align: 'left'},
    {props: 'statusName', label: '状态', width: 100, align: 'left'},
    {props: 'areaValue', label: '租赁/退租面积（㎡）', isArea: true, align: 'left'},
    {props: 'estimatedClosingPrice', label: '预估成交价格（元/㎡·月）', isEstimatedPrice: true, align: 'center'},
])

/**子数据动态**/
const getDynamicsData = async () => {
    let {data} = await request({
        url: GetCityAreaMarketDynamics,
        method: 'get',
        data: {areaCode: props.code}
    })
    dynamicsData.value = data
}

/*行业分布*/
const industryDistribution = ref([]);
const getCityAreaTenant = async () => {
  let {data} = await request({
    url: GetCityAreaTenant,
    method: 'get',
    data: {areaCode: props.code}
  })
  industryDistribution.value = data
}

/**现有存量**/
const currentInventory = ref([])
const getCurrentInventory = async () => {
  let {data} = await request({
    url: GetCurrentInventory,
    method: 'get',
    data: {areaCode: props.code}
  })
  currentInventory.value = data
}

/**市场体量分析**/
const marketVolume = ref([])
const getCityMassAnalysis = async () => {
  let {data} = await request({
    url: GetCityMassAnalysis,
    method: 'get',
    data: {areaCode: props.code}
  })
  marketVolume.value = data
}


watch(props, () => init(), {immediate: true})
async function init(){
  await getExpectNewData();
  //仓储数据总览
  await getWarehouse()
  // 项目数据一览
  await getChildData()
  // 租户行业分布
  await getCityAreaTenant();
  // 市场体量分析
  await getCityMassAnalysis();
  // 现有存量
  await getCurrentInventory();
  // 租金空置率情况
  await getChartInfo()
  // 租赁动态
  await getDynamicsData()
}

</script>

<style lang="less">
@import "../index.less";
.router-link{
  display: inline-block;
  width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.high-box {
    width: 100%;

    .high-top {
        .high-export{
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>.el-button {
                width: 109px;
                height: 36px;
                background: #1477C9;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                .el-image{
                    width: 16px;
                    height: 15px;
                    margin-right: 8px;
                }
            }
        }
        .data-list {
            .el-row {
                .el-col {
                    margin-top: 20px;
                    height: 235px;
                    //margin-bottom: 20px;
                }

            }
        }

        .data-chart {
            & > .el-row {
                .el-col {
                    margin-top: 20px;
                    //margin-bottom: 20px;
                }

                .margin-0 {
                    margin: 0;
                }
            }

            .chart-style {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                height: 360px;
                background: #FFFFFF;
                position: relative;
                box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                .chart-style-box{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
                .chart-style-box1{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 50px;
                    box-sizing: border-box;
                }
                .chart-style-item {
                    padding-top: 0;
                    width: 100%;
                    box-sizing: border-box;
                    height: 300px;
                    background: #FFFFFF;
                }

                .chart-title {
                    position: absolute;
                    top: 40px;
                    z-index: 9;
                    font-size: 16px;
                    color: @text-color-title;
                    font-weight: 700;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    width: 100%;
                }

                .chart-center-style {
                    width: 70px;
                    flex-shrink: 0;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #1477C9;
                    font-size: 12px;

                    z-index: 9;

                    .jiantou {
                        display: inline-block;
                        height: 1px;
                        width: 44px;
                        background: #F2F6FE;
                        border: 1px dashed #1477C9;
                        margin-bottom: 5px;
                        position: relative;

                        &::before {
                            content: "";
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid transparent;
                            border-left-color: #1477C9;
                            position: absolute;
                            right: -12px;
                            top: -6px;
                        }
                    }
                }

            }
        }
    }
}
</style>